import dagre from "dagre";

const nodeWidth = 172;
const nodeHeight = 36;

export const layoutNodes = (nodes, edges, direction = "TB") => {
  const g = new dagre.graphlib.Graph();
  g.setDefaultEdgeLabel(() => ({}));
  g.setGraph({ rankdir: direction });

  nodes.forEach((node) =>
    g.setNode(node.id, { width: nodeWidth, height: nodeHeight })
  );
  edges.forEach((edge) => g.setEdge(edge.source, edge.target));

  dagre.layout(g);

  return nodes.map((node) => {
    const { x, y } = g.node(node.id);
    return {
      ...node,
      position: { x: x - nodeWidth / 2, y: y - nodeHeight / 2 },
    };
  });
};
